import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CONSTRUCT_CONFIRMATION_TITLE = (
    <FormattedMessage
        id='building_construct_confirmation.title'
        defaultMessage={'Подтверждение строительства'}
    />
)

export const CONSTRUCT_CONFIRMATION_SUBMIT = (
    <FormattedMessage
        id='building_construct_confirmation.submit'
        defaultMessage={'Подтвердить'}
    />
)

export const CONSTRUCT_CONFIRMATION_QUESTION = (buildingName, industrialResource) => (
    <FormattedMessage
        id='building_construct_confirmation.construct_confirmation_question'
        defaultMessage={'Возвести строение {buildingName} за {industrialResource}\u00a0?'}
        values={{
            industrialResource,
            buildingName,
        }}
    />
)



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructConfirmation/constants.jsx